import PropTypes from 'prop-types';
import { Container } from 'theme-ui';
import SimpleArticleCard from '~/components/Article/Card/simple';
import React from 'react';

const ArticleSection = React.memo(function ArticleSection({ articles }) {
  return (
    <Container sx={{ padding: [0, 0, '0 var(--horizontal-inset)'], pb: ['9.6rem', '10.6rem', '13.6rem'] }}>
      {articles.map((article) => (
        <SimpleArticleCard article={article} key={article.id} />
      ))}
    </Container>
  );
});

ArticleSection.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.shape({
    description: PropTypes.string,
  }),
  articles: PropTypes.arrayOf(PropTypes.shape({})),
};

export default ArticleSection;
